import { createContext, useCallback } from 'react';
import { useLocalStorage } from './useLocalStorage';

export const TablePreferencesContext = createContext();

const defaultPreferences = { currentPage: 1, tablePageSize: 100, dateSortOrder: 'ascend' };

export const useTablePreferences = () => {
  const [tablePreferences, setTablePreferences] = useLocalStorage('table-preferences', {});

  const updateTablePreferences = (key, updates) => {
    setTablePreferences({
      ...tablePreferences,
      [key]: tablePreferences[key]
        ? { ...tablePreferences[key], ...updates }
        : { ...updates }
    })
  }

  const getTablePreferences = useCallback((key, defaults = defaultPreferences) => {
    if (!(key in tablePreferences)) {
      updateTablePreferences(key, defaults);
      return defaults;
    }
    else {
      return tablePreferences[key];
    }
  }, [tablePreferences, updateTablePreferences])

  return {
    tablePreferences,
    getTablePreferences,
    updateTablePreferences,
  }
}
